import * as yup from 'yup'
import { mediaSchema, validateMedia } from '@/components/inputs'

export const schema = yup.object({
  specie: yup.string().required(),
  amount: yup.string().required(),
  counting_method: yup.string().required(),
  wind_direction: yup.string().required(),
  direction: yup.string().required(),
  amount_per_15_min: yup.string().required(),
  notes: yup.string().max(256),
  recording_number: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value)),
  observed_at: yup.date().required(),
  photos: mediaSchema,
  sound_recordings: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 3,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
})
